import { type Board, type Clip } from '@air/api/types';

import { type DraggingItems, DragType, isBoardDragType } from '~/components/Shared/Drag/dragTypes';

const CLIP_DRAG_TYPES: DragType[] = [DragType.asset, DragType.file, DragType.assetPicker];

export function hasClipFirstItem(items: DraggingItems<Board | Clip>): items is DraggingItems<Clip> {
  return CLIP_DRAG_TYPES.includes(items.type);
}

export function hasBoardFirstItem(items: DraggingItems<Board | Clip>): items is DraggingItems<Board> {
  return isBoardDragType(items.type);
}
